/** Uçuş rezervasyon API hata metnini kullanıcıya gösterilebilir string'e çevirir. */
export function extractFlightBookingError(error) {
  const data = error?.response?.data;
  if (!data) {
    return error?.message || 'Rezervasyon oluşturulamadı';
  }
  const detail = data.detail ?? data.message ?? data.error;
  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }
  if (Array.isArray(detail)) {
    return detail
      .map((item) => (typeof item === 'string' ? item : item?.msg || JSON.stringify(item)))
      .filter(Boolean)
      .join(' ');
  }
  if (typeof detail === 'object' && detail !== null) {
    return detail.message || detail.msg || JSON.stringify(detail);
  }
  return 'Rezervasyon oluşturulamadı';
}
